import React from 'react';

import { Helmet } from 'react-helmet';

import Layout from '../components/Layout';
import Main from '../components/Reports';
import Sidebar from '../components/Sidebar';
import Toolbar from '../components/Toolbar';

const title = 'Rapporter | Aktieutdelningar';
const desc = 'Se kommande och historiska rapporter för de värdepapper du har lagt till som innehav.';

export default function OverviewView() {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={desc} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={window.location.href} />
        {/* <meta property="og:image" content={NextoryMetaImg} /> */}
        <meta name="twitter:title" content={title} />
      </Helmet>

      <Sidebar mobile />
      <Layout>
        <Toolbar />
        <Sidebar desktop />
        <Main />
      </Layout>
    </>
  );
}
